import { createApp } from "vue";
import Cart from "./components/Cart.vue";
let cartInstance = null;

document.addEventListener("DOMContentLoaded", () => {
  const cartContainer = document.getElementById("amprod-cart");

  if (!cartContainer) return console.warn("Cart container not found");

  // Check if we're in the dropdown context
  const isDropdownMode =
    cartContainer.closest(".amprod-quote-hover-cart") !== null;

  // Mount the Cart component
  const cartApp = createApp(Cart, {
    apiBaseUrl: window.amprodCartData?.apiBaseUrl || "",
    showHeader: !isDropdownMode, // Hide header in dropdown mode
    showActions: !isDropdownMode, // Hide actions in dropdown mode (they're in the fixed footer)
    isDropdownMode: isDropdownMode,
  });

  // Mount the app
  cartInstance = cartApp.mount(cartContainer);
  setTimeout(() => window.amprodQuoteIconUpdate(), 100);
});

// Global cart object - the only interface for adding to cart
window.amprodCart = {
  addToCart: (quoteData) => {
    // Direct method call to cart component
    const result = cartInstance.addItem(quoteData);

    // Notify quote icon of cart update
    if (window.amprodQuoteIconUpdate) {
      setTimeout(() => window.amprodQuoteIconUpdate(), 100);
    }

    return result;
  },

  updateCartItem: (configId, quoteData) => {
    console.log("Updating cart item:", configId, quoteData, cartInstance);
    // Direct method call to cart component for updates
    const result = cartInstance.updateItem(configId, quoteData);

    // Notify quote icon of cart update
    if (window.amprodQuoteIconUpdate) {
      setTimeout(() => window.amprodQuoteIconUpdate(), 100);
    }

    return result;
  },

  getCartItems: () => {
    try {
      const cartData = localStorage.getItem("amprod_cart");
      return cartData ? JSON.parse(cartData) : [];
    } catch (error) {
      console.error("Error getting cart items:", error);
      return [];
    }
  },

  getCartCount: () => {
    try {
      const cartData = localStorage.getItem("amprod_cart");
      const items = cartData ? JSON.parse(cartData) : [];
      return items.length;
    } catch (error) {
      console.error("Error getting cart count:", error);
      return 0;
    }
  },

  getCartItemById: (configId) => {
    try {
      const cartData = localStorage.getItem("amprod_cart");
      const items = cartData ? JSON.parse(cartData) : [];
      // Convert both IDs to strings for comparison since URL params are strings
      const targetId = String(configId);
      const item = items.find((item) => String(item.id) === targetId);
      return item || null;
    } catch (error) {
      console.error("Error getting cart item by ID:", error);
      return null;
    }
  },

  removeCartItem: (index) => {
    try {
      const cartData = localStorage.getItem("amprod_cart");
      const items = cartData ? JSON.parse(cartData) : [];

      if (index >= 0 && index < items.length) {
        items.splice(index, 1);
        localStorage.setItem("amprod_cart", JSON.stringify(items));

        // Update Vue component if available
        if (cartInstance && cartInstance.cartItems) {
          cartInstance.cartItems = items;
        }

        // Notify quote icon of cart update
        if (window.amprodQuoteIconUpdate) {
          window.amprodQuoteIconUpdate();
        }

        console.log("AmProd Cart: Item removed successfully");
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error removing cart item:", error);
      return false;
    }
  },

  clearCart: () => {
    try {
      // Clear localStorage first
      localStorage.removeItem("amprod_cart");

      // Update Vue component state directly
      if (cartInstance && cartInstance.cartItems) {
        cartInstance.cartItems = [];
        cartInstance.errorMessage = null;
      }

      // Notify quote icon of cart update
      if (window.amprodQuoteIconUpdate) {
        window.amprodQuoteIconUpdate();
      }

      console.log("AmProd Cart: Cart cleared successfully");
      return true;
    } catch (error) {
      console.error("Error clearing cart:", error);
      return false;
    }
  },

  // Populate Gravity Form fields with cart data
  populateGravityFormField: (fieldIdentifier) => {
    const configurations = window.amprodCart.getCartItems();

    if (!configurations.length) {
      return false;
    }

    // Try multiple ways to find the field
    let field = null;

    // Try by field ID first (preferred method)
    if (fieldIdentifier) {
      // Check if it's a numeric field ID
      if (/^\d+$/.test(fieldIdentifier)) {
        // Get the form ID from the form element
        const formElement = document.querySelector("form.gform_wrapper form");
        if (formElement) {
          const formId = formElement.id.replace("gform_", "");
          field = document.querySelector(`#input_${formId}_${fieldIdentifier}`);
        }

        // Fallback: try to find any input with this field ID pattern
        if (!field) {
          field = document.querySelector(`input[id*="_${fieldIdentifier}"]`);
        }
      } else {
        // Try by admin label (backward compatibility)
        field = document.querySelector(
          `input[data-admin-label="${fieldIdentifier}"]`
        );
      }
    }

    if (field) {
      field.value = JSON.stringify(configurations);
      console.log(
        "AmProd Cart: Populated form field with cart data",
        configurations
      );
      return true;
    }

    console.error(
      "AmProd Cart: Could not find configuration field to populate"
    );
    return false;
  },
};
